export default "data:image/webp;base64,UklGRkoAAABXRUJQVlA4TD4AAAAvUAWzEAdQuB6VKQIAivT/P0X0P/W///3vf//73//+97///e9///vf//73v//973//+9///ve///3vf/8rDA=="